import _ from "lodash";
import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import { EmptyState, SearchInput, Tag } from "@toddle-edu/ds-web";
import { NoSearchResultsIllustration } from "@toddle-edu/ds-theme";
import { ChevronRightOutlined } from "@toddle-edu/ds-icons";
import CycleCard from "AppComponents/SnPCyclesFeedV2/CycleCard";
import { KeyboardNavigableList } from "UIComponents/KeyboardNavigableList";
import { cardStyles } from "./EvaluationCyclesStyles";
import classes from "./EvaluationCycles.scss";

const EvaluationCycles = props => {
  const {
    updateCurrentCycle,
    cycles,
    closeButtonElement,
    t,
    cycleIdToTaggedPracticesCountMapping,
    testId,
  } = props;
  const cyclesScrollContainerRef = useRef(null);

  const totalCycles = _.size(cycles);

  const firstCycleId = _.get(_.first(cycles), "id", "");

  const titleClasses = classNames(classes.title);

  useEffect(() => {
    /**To show Practices when there is only 1 cycle */
    if (totalCycles === 1) updateCurrentCycle({ id: firstCycleId });
  }, [totalCycles, firstCycleId, updateCurrentCycle]);

  const [searchTextForCycles, setSearchTextForCycles] = React.useState("");

  const filteredCycles = _.filter(cycles, cycle => {
    return _.includes(_.toLower(cycle?.title), _.toLower(searchTextForCycles));
  });

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <h6 className={titleClasses}>{`${t("common:tag_snp")}`}</h6>
        {closeButtonElement}
      </div>
      <div className={classes.searchContainer}>
        <SearchInput
          size="medium"
          onChange={setSearchTextForCycles}
          placeholder={t("common:search_for_with_label", {
            label: t("snp:cycle_plural"),
          })}
          dsVersion={"2.0"}
          focusSearchBySlash={true}
          testId={`${testId}-evaluationCycles`}
        />
      </div>
      {!_.isEmpty(filteredCycles) ? (
        <div className={classes.cyclesContainer}>
          <KeyboardNavigableList listContainerRef={cyclesScrollContainerRef}>
            <div
              className={classes.cyclesScrollContainer}
              ref={cyclesScrollContainerRef}
            >
              {_.map(filteredCycles, cycle => {
                const taggedCount =
                  cycleIdToTaggedPracticesCountMapping[cycle.id];
                return (
                  <CycleCard
                    key={cycle.id}
                    cycle={cycle}
                    testId={testId}
                    onClickCard={updateCurrentCycle}
                    cycleActionsElement={
                      <ChevronRightOutlined
                        size={"xxx-small"}
                        variant={"subtle"}
                      />
                    }
                    titleSuffix={
                      taggedCount > 0 ? (
                        <Tag dsVersion="2.0" size="small">
                          {t("snp:count_tagged", { count: taggedCount })}
                        </Tag>
                      ) : null
                    }
                    cardStyles={cardStyles}
                  />
                );
              })}
            </div>
          </KeyboardNavigableList>
        </div>
      ) : (
        <div className={classes.noDataContainer}>
          <EmptyState
            dsVersion="2.0"
            illustration={NoSearchResultsIllustration}
            title={t("common:no_items_found", {
              item: t("snp:cycle_plural"),
            })}
            size="small"
          />
        </div>
      )}
    </div>
  );
};

export default EvaluationCycles;
